export class ConfiguracoesAcidentesPessoais {

    fumante: boolean
    isAppMorteAcidental: number
    isAppInvalidez: number
    praticaEsporteRadical: number
    DIT: any
    funeral: any

    constructor() {
        this.fumante = null;
        this.isAppMorteAcidental = null;
        this.isAppInvalidez = null;
        this.praticaEsporteRadical = null;
        this.DIT = { qtdDiarias: null, valor: null };
        this.funeral = { tipo: null, valor: null };
    }
}